import { useState, useEffect } from "react";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";
import { getWindowDimensions } from "lib/utilities/misc";

import FeatureVariation from "lib/classes/featurevariation";
import Vector2 from "lib/classes/vector2";
import MapToolMode from "lib/enums/maptoolmode";

import "styles/css/VariationsPopup.scss";

const FeatureVariationPopup = new Popup({
	title: function() {
		const modeName:string = getLocaleString(this.get("mode-name").toLowerCase());
		
		return getLocaleString("fmodetype", [modeName]);
	},
	style: {maxWidth: 550, minHeight: 200},
	render: function() {
		const [currentVariation, setCurrentVariation] = useState<FeatureVariation>(this.get("active-variation"));
			
		const options:FeatureVariation[] = this.get("variations");
		const onSelect:Function = this.get("onselect");
		const modeName:string = this.get("mode-name");
		
		// Ensure the state's variation is always correct
		useEffect(() => {
			setCurrentVariation(this.get("active-variation"));
		}, [this.get("active-variation")]);
		
		useEffect(() => {
			_events.on("tool-mode-changed", (toolMode:MapToolMode) => {
				if(toolMode != MapToolMode.Draw && _ui.isPopupOpen(this)) {
					_ui.closePopupOf(this);
				}
			});
		}, []);
		
		const selectVariation = (variation:FeatureVariation) => {
			setCurrentVariation(variation);
			onSelect(variation);
		}
		const drawOptions = () => {
			const rows:Array<any> = [];
			
			options.forEach((variation:FeatureVariation) => {
				let className:string = "unit-option";
				
				if(currentVariation?.id == variation.id)
					className += ` unit-option--selected ${_ui.getSelClassName()}`;
					
				const getImageURL = () => {
					return variation.image || assetURL(`assets/images/${modeName.toLowerCase()}.png`);
				}
				const onClick = () => selectVariation(variation);
				
				rows.push(
					<div 
						className={className} 
						key={options.indexOf(variation)} 
						onClick={onClick}
						onKeyDown={(e:any) => {
							if (e.key === 'Enter')
								onClick();
						}}
						tabIndex={options.indexOf(variation) + 200}
					>
						<img src={getImageURL()} />
						{variation.getName()}
					</div>
				);
			});
			
			return rows;
		}
		const drawNoOptions = () => {
			return (
				<div style={{height: 100}}>
					{getLocaleString("nooptionsavail")}
				</div>
			)
		}
		const drawVariationInfo = () => {
			if(!currentVariation) {
				return (
					<>
						<div className="variation-info--heading">
							{getLocaleString("nofvselected")}
						</div>
					</>
				)
			}
			return (
				<>
					<div className="variation-info--heading">
						<div className="circle" style={{
								background: currentVariation?.colorHex, 
								marginRight: 8
						}}></div>
						
						{currentVariation?.getName?.()}
					</div>
					<div className="variation-info--description">
						{currentVariation?.getDescription?.() || getLocaleString("nofvdesc")}
					</div>
				</>
			)
		}
		
		return (
			<div className="variations-container">
				<div className="variations-list">
					{options ? drawOptions() : drawNoOptions()}
				</div>
				<div className="variation-info">
					{drawVariationInfo()}
					<div className="variation-info--close">
						<button onClick={() => _ui.closePopupOf(this)} style={{width: 80}}>
							{getLocaleString("done")}
						</button>
					</div>
				</div>
			</div>
		)
	}
});

export default FeatureVariationPopup;